import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { PARTNER_CONSOLIDATED_REPORTS_FLAG } from 'tio-employee/types/partner-reports';
import type FeaturesService from 'tio-common/services/features';
import type PartnerDashboardsService from 'tio-employee/services/partner-dashboards';
import type RouterService from '@ember/routing/router';

/**
 * With the consolidated page live this listing moves into its Legacy Dashboards section, so
 * the route redirects rather than 404s — the URL is bookmarked. Behind the flag it still
 * renders the QuickSight grid. `authenticated.admin.reports.show` serves the embeds either way.
 */
export default class AuthenticatedAdminReportsIndexRoute extends Route {
  @service declare features: FeaturesService;
  @service declare partnerDashboards: PartnerDashboardsService;
  @service declare router: RouterService;

  /** Redirects to the consolidated page when the flag is on; otherwise falls through to the grid. */
  beforeModel() {
    if (this.features.isEnabled(PARTNER_CONSOLIDATED_REPORTS_FLAG)) {
      this.router.replaceWith('authenticated.admin.reporting.index');
    }
  }

  async model() {
    return this.partnerDashboards.loadAndFilterReportsForPartner();
  }

  /** @param model the partner's QuickSight dashboards, as loaded above */
  afterModel(model: { id: string }[]) {
    if (this.features.isEnabled(PARTNER_CONSOLIDATED_REPORTS_FLAG)) return;

    // A partner with a single dashboard has no listing worth showing.
    if (model.length === 1) {
      this.router.transitionTo('authenticated.admin.reports.show', model[0]?.id ?? '');
    }
  }
}
